import { InjectionToken } from '@angular/core';

export const PERMISSIONS_CONFIG = new InjectionToken('permissions_config');

export interface PermissionsConfiguration<
  TRole extends string = any,
  TPermission extends string = any,
  TPermissionSet extends string = any,
> {
  roles: TRole[];
  permissions: TPermission[];
  permissionSets?: {
    [key: string]: TPermission[];
  };
  grants: {
    roles?: RoleGrants<TRole, TPermission, TPermissionSet>;
    all?: {
      permissions?: TPermission[] | 'all';
      permissionSets?: TPermissionSet[];
    };
  };
}

export type RoleGrants<
  TRole extends string,
  TPermission extends string,
  TPermissionSet extends string,
> = {
  [key in TRole]?: {
    permissions?: TPermission[] | 'all';
    permissionSets?: TPermissionSet[];
    inherits?: TRole[];
  };
};
